import { useEffect } from 'react'
import useGetVerifyTransactions from './hooks/useGetVerifyTransactions'
import { useNavigate } from 'react-router'
import { toast } from 'react-toastify'
import useGetFuckHamyan from './hooks/useGetFuckHamyan'
import posthog from 'posthog-js'

export default function Verify() {
    const { data, isLoading } = useGetVerifyTransactions()
    const navigate = useNavigate()
    const items = JSON.parse(localStorage.getItem('toBePaidTransactions')!)
    const { mutate } = useGetFuckHamyan()
    useEffect(() => {
        if (data) {
            if (data.state === 'scss') {
                // Single source of truth for a completed gateway payment.
                posthog.capture('payment_succeeded', {
                    amount: data.amount,
                    commission: data.commission,
                    gateway: data.gateway,
                    transaction_pk: data.pk,
                    flow_type: items?.type,
                })
                if (items?.type === 'group-all-payment') {
                    navigate('/group-all-payment', {
                        state: { isWalletCharged: true },
                    })
                } else if (items?.type === 'pay-for-others') {
                    const payload: IAddOnlinePayForOtherPayload = items?.data[0]
                    mutate(payload)
                } else {
                    navigate('/funds')
                }
            } else {
                posthog.capture('payment_failed', {
                    payment_status: data.state,
                    transaction_pk: data.pk,
                    flow_type: items?.type,
                })
            }
        }
    }, [isLoading, data])
    return (
        <div>
            {!isLoading && data && data.state !== 'scss' && (
                <div className=" h-screen flex flex-col justify-center">
                    <p className=" text-red-1 text-3xl text-center my-4">
                        پرداخت ناموفق
                    </p>
                    <button
                        className=" mx-2 border-1 border-red-1 bg-red-1 rounded-md py-3 text-white"
                        onClick={() => {
                            localStorage.removeItem('toBePaidTransactions')
                            navigate('/funds')
                        }}
                    >
                        بازگشت
                    </button>
                </div>
            )}
        </div>
    )
}
